
// components/Tracking.js
import React, { useState } from 'react';
import trackingBg from '../assets/images/3.jpeg';

function Tracking() {
  const [trackingNumber, setTrackingNumber] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    // Implement tracking functionality here
    console.log('Tracking number submitted:', trackingNumber);
    // You would typically call an API here
  };

  return (
    <section className="track_section layout_padding">
      <div className="track_bg_box">
        <img src={trackingBg} alt="Shipment Tracking" />
      </div>
      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <div className="heading_container">
              <h2>Track Your Shipment</h2>
            </div>
            <p>
              Stay updated on your shipment's journey in real-time. Simply enter your tracking number below to get the latest status, estimated delivery time, and location updates. We ensure secure and timely deliveries to your doorstep.
            </p>
            <form onSubmit={handleSubmit}>
              <input 
                type="text" 
                placeholder="Enter Your Tracking Number" 
                required 
                value={trackingNumber}
                onChange={(e) => setTrackingNumber(e.target.value)}
              />
              <button type="submit">Track</button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Tracking;